module.exports = __webpack_public_path__ + "img/circle.1cf13eff.png";